/**
*
* LandingMenuBar
*
*/

import React from 'react';
import styled, { css } from 'styled-components';

import { ContainerFlex } from '../Blocks';

import media from '../../style/mediainjector';

export const ClearLink = styled.a`
  color: inherit;
  display: inherit;
  text-decoration: inherit;
  cursor: pointer;
`;

export const MenuBar = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 72px;
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : 'rgba(255, 255, 255, 0.95)')};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  z-index: 8;
  ${media.gt667`
    ${({ start }) => start > 0 && css`
      height: 96px;
      box-shadow: none;
      background-color: ${(props) => (props.bgStartColor)};
    `}
  `}
  ${media.lt667`
    ${({ openNav }) => openNav && css`
      background: none;
      overflow: visible;
    `}
  `}
  transition: all 0.3s;
  * {
  transition: all 0.3s;
  }
`;

export const LandingMenu = styled(ContainerFlex)`
  height: 100%;
  color: ${(props) => (props.color ? props.color : props.theme.brand)};
  justify-content: space-between;
  ${media.mobile`
    padding: 0 20px;
  `}
  ${media.lt667`
    overflow: visible;
    nav {
      display: none;
    }
    ${({ openNav }) => openNav && css`
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      padding: 60px 20px;
      flex-direction: column;
      justify-content: space-around;
      background-color: rgba(255, 255, 255, 0.95);
      nav {
        display:block;
        a {
          display: block;
          margin: 40px auto;
          font-size: 21px;
          text-align: center;
          padding: 6px 22px;
          ${media.iphone45`
            margin: 14px auto;
          `}
        }
      }
    `}
  `}
`;

// TODO: capire come testare montando il router
export const BarMenuItem = styled(ClearLink)`
  color: ${(props) => props.color};
  font-size: 18px;
  display: inline-block;
  text-decoration: none;
  padding: 2px 12px 3px;
  margin: 0 2px;
  background-image:none;
  cursor: pointer;
  &:hover{
    border-radius: 100px;
    color: ${(props) => (props.color ? props.color : 'inherit')};
    border-radius: 100px;
  }
  &:last-child {
    margin-right: 0;
  }
  ${/* istanbul ignore next */({ activeLink }) => activeLink && css`
    color: ${(props) => (props.activeColor ? props.activeColor : '#fff')};
    background-color: ${/* istanbul ignore next */(props) => props.theme.brand};
    border-radius: 100px;
    pointer-events: none;
  `}
`;

export const MobileNavBtn = styled.a`
  display:flex;
  cursor: pointer;
  ${media.gt667`
    display: none;
  `}
`;


// icons
export const icons = {
  hamburger: {
    path: <path d="M0 0h24v2H0zM0 18h24v2H0zM0 9h24v2H0z" fillRule="evenodd" />,
    viewBox: '0 0 24 20',
    width: '24px',
    height: '20px',
  },
  close: {
    path: <path fillRule="evenodd" d="M23.557 20l14.665 14.665L40 36.443 36.443 40l-1.778-1.778L20 23.557 5.335 38.222 3.557 40 0 36.443l1.778-1.778L16.443 20 1.778 5.335 0 3.557 3.557 0l1.778 1.778L20 16.443 34.665 1.778 36.443 0 40 3.557l-1.778 1.778L23.557 20z" />,
    viewBox: '0 0 40 40',
    width: '20px',
    height: '20px',
  },
};
